import {LitElement, html, css} from 'lit';
import {customElement} from 'lit/decorators/custom-element.js';
import {connect} from 'pwa-helpers';
import store from '../../../store';
@customElement('visual-iomo-3d')
export class VisualIomo3d extends connect(store)(LitElement) {

	static styles = css`
		:host {
			display: flex;
			width: 100%;
			height: 100%;
			overflow: hidden;
		}
		.container {
			width: 100%;
		}
	`;

	constructor() {
		super();
		store.subscribe(() => this.requestUpdate());
	}
	stateChanged(state) {
		this.state = state;
		this.lang = state.status.lang;
		this.region = state.status.region;
		this.translations = state.productData.translations;
	}
	render() {
		const s = this.state;
		return html`
			<div class="container">
				<iomo-3d></iomo-3d>
			</div>
		`;
	}
}
